import { createSlice } from '@reduxjs/toolkit';
import BaseError from '../../../utils/base-error';
import { PortfolioEventsPageState } from './state';
import { PortfolioEventsPageActions } from './actions';
import {
    createCateringEventCategoriesFromGetCateringEventCategoriesApiResponse,
    createPortfolioEventCardsFromGetPortfolioEventCardsApiResponse,
} from '../utils';

const initialState: PortfolioEventsPageState = {
    loaded: false,
    errors: [],
    portfolioEventsCards: [],
    eventCategories: [],
};

export const portfolioEventsPageSlice = createSlice({
    name: 'portfolioEventsPageSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            PortfolioEventsPageActions.getCateringEventCategories.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        // eslint-disable-next-line max-len
                        const result = createCateringEventCategoriesFromGetCateringEventCategoriesApiResponse(
                            response.data,
                        );

                        state.eventCategories = result;
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            PortfolioEventsPageActions.getPortfolioEventCardsByCategoryUid.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        // eslint-disable-next-line max-len
                        const result = createPortfolioEventCardsFromGetPortfolioEventCardsApiResponse(
                            response.data,
                        );

                        state.portfolioEventsCards = result;
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
    },
});
